/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Searchcountry1Inputs */

const he_common_searchcountry1 = /** @type {(inputs: Common_Searchcountry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חפש מדינה...`)
};

const en_common_searchcountry1 = /** @type {(inputs: Common_Searchcountry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search country...`)
};

/**
* | output |
* | --- |
* | "Search country..." |
*
* @param {Common_Searchcountry1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_searchcountry1 = /** @type {((inputs?: Common_Searchcountry1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Searchcountry1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_searchcountry1(inputs)
	return en_common_searchcountry1(inputs)
});
export { common_searchcountry1 as "common_searchCountry" }